import { Component } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@Component({
  selector: 'fgbcl-not-enough-points-reward-status',
  standalone: true,
  imports: [FGBSharedModule],
  templateUrl: './not-enough-points-reward-status.component.html',
  styleUrl: './not-enough-points-reward-status.component.scss',
})
export class NotEnoughPointsRewardStatusComponent {}
